export const LANG_ES_NAME = "es";

export const LANG_ES_TRANS = {
	"account.delete.title": "¿Desea borrar su cuenta?",
	"application.create.title": "Crear una nueva Aplicación Protegida",
	"application.edit.title": "Configurar Aplicación Protegida",
	"application.form.label.name": "Nombre de la Aplicación",
	"application.form.label.web": "Aplicación Web",
	"application.form.label.network": "Red",
	"applications.add.text": "Añadir",
	"applications.header.title": "Applicaciones",
	"applications.info.block.1": `El concepto de aplicación protegida esta definido por la configuracion de como acceder a esa aplicación.
		La aplicación protegida puede ser asignada a grupos de usuarios específicos según sea necesario. Sólo los miembros del
		grupo asociado podrán solicitar acceso a la aplicación.`,
	"applications.info.maximum.applications.created": "Ha asignado el número máximo de aplicaciones permitido.",
	"applications.label.application": "Aplicación",
	"applications.label.ip": "IP o Nombre de Host",
	"applications.label.portNumber": "Puerto",
	"applications.label.name": "Nombre",
	"applications.label.proto": "Protocolo",
	"applications.label.roles": "Grupos",
	"applications.label.webUrl": "URL Web",
	"applications.label.keepAlive": "Permitir Nuevas Conexiones",
	"applications.label.image": "Imagen",
	"error.form.ip": "Debe introducir una dirección IP válida",
	"error.form.portNumber": "Debe ingresar un número de puerto entre 1 y 65535",
	"error.form.name": "Debe especificar un nombre",
	"error.form.webUrl": "Debe especificar una URL web",
	"error.form.name.duplicate": "Ya existe una aplicación con este nombre",
	"error.form.passwordDoNotMatch": "Las contraseñas no coinciden",
	"error.form.urlPrefix": "Debe introducir un prefijo de URL",
	"error.form.duplicate.resource": `La combinación de "IP o nombre de host", "Puerto" y "Sufijo de URL" está en
		conflicto con otro recurso. Edite este recurso para evitar crear un duplicado.`,
	"error.message.accessCode": "Debe introducir un código de acceso.",
	"error.meesage.account": "Debe ingresar un nombre de sitio web.",
	"error.message.codeMisMatch": `Código de registro no válido. Revise su correo electrónico de nuevo para ver
		el código de registro correcto.`,
	"error.message.currentPassword": "Debe introducir su contraseña actual.",
	"error.message.email": "Debe ingresar una dirección de correo electrónico válida",
	"error.message.expiredCode": `Esta cuenta ya está confirmada o el código de registro ha caducado. Intente
		iniciar sesión o registrar una cuenta nueva.`,
	"error.message.firstname": "Debe entrar su nombre.",
	"error.message.lastname": "Debe entrar su apellido.",
	"error.message.password": "Debe especificar una contraseña.",
	"error.message.passwordMatch": "Las contraseñas no coinciden.",
	"error.message.totp": "Debe ingresar un código válido",
	"error.message.userNotFound": "No hay ninguna cuenta registrada con esta dirección de correo electrónico. Registre una nueva cuenta.",
	"error.message.wrongCode": "No se aceptó el código de activación",
	"error.message.sendingNewConfirmationEmail": `Ha ocurrido un error al enviar el correo electrónico de confirmación.
		Intente iniciar sesión de nuevo.`,
	"error.message.registration.accountBeingDeleted": "Una cuenta con este nombre esta siendo eliminada. Vuelva a intentarlo en breve.",
	"error.message.registration.accountAlreadyExists": "Ya existe una cuenta con este nombre.",
	"error.message.registration.emailAlreadyRegistered": "Esta dirección de correo electrónico ya está registrada.",
	"footer.rights": "TODOS LOS DERECHOS RESERVADOS",
	"forgotpassword.title": "Se le olvidó su contraseña",
	"forgotpassword.description": "Introduzca su dirección de correo electrónico para iniciar la recuperación de contraseña",
	"form.label.accessCode": "Código de acceso",
	"form.label.back": "Regresar",
	"form.label.comment": "Commentar",
	"form.label.company": "Empresa",
	"form.label.confirmNewPassword": "Confirmar nueva contraseña",
	"form.label.confirmPassword": "Confirmar contraseña",
	"form.label.continue": "Continuar",
	"form.label.country": "País",
	"form.label.currentPassword": "Contraseña actual",
	"form.label.email": "Dirección de correo electrónico",
	"form.label.firstname": "Nombre",
	"form.label.firstLastname": "Nombre y apellido",
	"form.label.lastname": "Apellido",
	"form.label.newPassword": "Nueva contraseña",
	"form.label.password": "Contraseña",
	"form.label.phone": "Número de teléfono",
	"form.label.resendConfirmation": "Reenviar correo electrónico",
	"form.label.register": "Registrar",
	"form.label.resetPassword": "Restablecer la contraseña",
	"form.label.signIn": "Iniciar sesión",
	"form.label.stateProvince": "Estado/Provincia",
	"forcePasswordChange.button.text": "Configurar la contraseña",
	"forcePasswordChange.description": "Por favor, provea una contraseña",
	"forgotpassword.change": "Introduzca una nueva contraseña",
	"forgotpassword.verify.1": "Se enviará un correo electrónico a",
	"forgotpassword.verify.3": "Compruebe su correo electrónico ahora y siga las instrucciones.",
	"forgotpassword.verify.4": "El enlace para resetear contraseña será válido por un tiempo limitado.",
	"header.item.administration": "Administración",
	"header.item.deleteAccount": "Borrar cuenta",
	"header.item.resetPassword": "Resetear contraseña",
	"header.item.settings": "Configuración",
	"header.item.signOut": "Desconectar",
	"header.sub.title": "Portal Seguro en la Nube",
	"home.browser.title": "Comenzar",
	"home.link.applications": "Aplicaciones: Las aplicaciones que está intentando proteger.",
	"home.link.users": "Usuarios: Individuos o grupos de usuarios que tienen acceso a determinadas aplicaciones.",
	"login.resetPasswordFailed": "Contraseña nueva no válida. Las contraseñas deben tener al menos ocho (8) caracteres.",
	"message.account.verified": "Su cuenta ha sido verificada. Introduzca su contraseña e inicie sesión para continuar",
	"message.account.verify": "Gracias por su solicitud, recibirá un correo electrónico en breve para verificar su cuenta",
	"message.account.resendConfirmation": `Su cuenta está pendiente de confirmación. ¿Desea volver a enviar el correo
		electrónico de confirmación?`,
	"message.account.invalidCode": `El código de confirmación de registro proporcionado no era válido.
        ¿Desea volver a enviar el correo electrónico de confirmación?`,
	"message.password.reset.successful": "El restablecimiento de contraseña se ha realizado correctamente",
	"message.password.signin.new": "Inicie sesión con su nueva contraseña.",
	"registration.create.title": "Crear una cuenta",
	"registration.form.account": "Su Cuenta",
	"registration.form.account.info": "Nombre de la cuenta",
	"registration.form.back.signIn": "Continuar para iniciar sesión",
	"registration.form.needCode": "Necesita un código de activación",
	"registration.policy.1": "He leído y estoy de acuerdo con",
	"registration.policy.2": "Política de privacidad",
	"registration.signIn.title": "Inicie sesión",
	"requestCode.description": "Ingrese su información para solicitar un código de activación para",
	"requestCode.send": "Enviar petición",
	"resetpassword.description": `Elija una nueva contraseña para esta cuenta de usuario. Esta contraseña
		reemplazará a la antigua, todo lo demas acerca de esta cuenta de usuario permanecerá sin cambios`,
	"resetpassword.success": `Su contraseña ha sido restablecida. Se le pedirá que use su nueva contraseña la próxima vez que inicie sesión.`,
	"resetpassword.title": "Restablecer la contraseña",
	"sdp.label.add": "Añadir",
	"sdp.label.create": "Crear",
	"sdp.label.create.add.new": "Crear y Adicionar Nueva",
	"sdp.label.update": "Actualizar",
	"sdp.label.cancel": "Cancelar",
	"sdp.label.previous": "Anterior",
	"sdp.label.next": "Siguiente",
	"sdp.label.done": "Listo",
	"sdp.label.delete": "Borrar",
	"sdp.label.send": "Enviar",
	"sdp.user.groups": "Grupos de Usuarios",
	"sdp.welcome.to": "Bienvenido a",
	"settings.title": "Configuración de Cuenta",
	"settings.mfa.header": "MFA",
	"settings.mfa.description": "Habilite autenticación de múltiples factores para proteger su cuenta.",
	"settings.mfa.setupButton.text": "Configuración",
	"summary.header.title": "Resumen",
	"tagger.placeholder": "Grupos",
	"user.create.title": "Crear un Usuario",
	"user.edit.title": "Actualizar un Usuario",
	"users.header.title": "Usuario",
	"userResourceList.header.title": "Mis Aplicaciones Protegidas",
	"userResourceList.noResources": `No hay recursos a los que se le haya proporcionado acceso. Póngase en contacto
		con el administrador de su cuenta para obtener acceso a los recursos protegidos.`,
	// 0710 new texts
	"imageManager.heading.title": "Tamaño y dimensiones del archivo",
	"imageManager.": "Subir una imagen",
	"imageManager.selector.button": "Seleccionar archivo",
	"message.forgotpassword.reset": "Su contraseña ha sido cambiada. Inicie sesión con su nueva contraseña",
	"user.edit.created": "Usuario [[username]] ha sido creado y se ha enviado una invitación por correo electrónico",
	// 0713
	"error.message.password.length.min": "La contraseña debe tener una longitud mayor o igual a 6",
	"error.message.account.required": "El nombre de la cuenta es requerido",
	// 0718 updates to existing
	"registration.form.account.tooltip": `Debe tener al menos 5 caracteres, números y letras solamente. Una vez que su cuenta ha sido
        aprovisionada, no se puede cambiar el nombre de la cuenta`,
	"account.delete.confirmation": `Esta acción NO SE PUEDE deshacer y borrará definitivamente su cuenta y todos los ajustes
        asociados. Por favor escriba el nombre de su cuenta \"[[accountName]]\" para confirmar la eliminación de su cuenta.`,
	"account.delete.placeholder": "Nombre de Cuenta",
	// 0720
	"assignApplications.edit.tooltip": "Agregar/Quitar asignaciones para aplicaciones",
	"assignApplications.clear.tooltip": "Eliminar todas las asignaciones de esta aplicación. La aplicación ya no será accesible",
	"assignApplications.grid.user-group": "Usuario/Grupo",
	"roles.noRoles": "Para asignar grupos, haga click en el botón Editar",
	"assignApplications.delete.dialog.message": "¿Está seguro de que desea eliminar todos los grupos de \"[[applicationName]]\"?",
	"assignApplications.delete.dialog.title": "Eliminar Grupos/Usuarios de Accesso a la Aplicación",
	"assignApplications.update.success.message.noRoles": `Todos los grupos de \"[[applicationName]]\" se han eliminado.
        Esta aplicación ya no está disponible.`,
	// 0727
	"applications.delete.dialog.message": "¿Esta seguro que quiere borrar '[[applicationName]]'?",
	"applications.delete.dialog.title": "Borrar Aplicación",
	"users.delete.dialog.message": "¿Esta seguro que quiere borrar '[[email]]'?",
	"users.delete.dialog.title": "Borrar Usuario",
	"users.sendEmail.dialog.message": "¿Seguro que desea volver a enviar el código de activación a '[[email]]'?",
	"users.sendEmail.dialog.title": "Reenviar código de invitación",
	"users.sendEmail.success.message": "Invitación enviada de nuevo a \"[[email]]\"",
	"assignments.update.success.message.roles": "\"[[applicationName]]\" ha sido actualizado",
	// messages the backend might send us
	"error.message.deleteAccount.alreadyBeingDeleted": "Esta cuenta ya se está eliminando.",
	"error.message.deleteAccount.genericError": "Ha ocurrido un error al eliminar esta cuenta.",
	"error.message.application.noPortsAvailable": `Todos los puertos de contenedores disponibles están en uso, por lo que no se pueden
        crear más recursos.`,
	"error.message.application.duplicateName": "Ya existe una aplicación con nombre \"[[name]]\".",
	"error.message.application.duplicateData": `Ya existe un recurso con IP \"[[ip]]\", puerto \"[[port]]\", y sufijo de
		URL \"[[urlSuffix]]\".`,
	"error.message.deleteApplication.notFound": "No existe aplicación con nombre \"[[name]]\".",
	"error.message.roles.duplicateName": "Ya existe un rol con nombre \"[[name]]\".",
	"error.message.deleteRole.notFound": "No existe rol con nombre \"[[name]]\".",
	"error.message.user.duplicateName": "Un usuario con correo electrónico \"[[name]]\" ya existe.",
	"error.message.deleteUser.notFound": "Ningún usuario con correo electrónico \"[[name]]\".",
	"error.access.genericError": "Ha ocurrido un error al solicitar acceso a esta aplicación.",
	"error.access.notAuthorized": "Usuario \"[[caller]]\" no está autorizado para acceder a la aplicación \"[[resourceName]]\".",
	"error.access.notFound": "No se ha encontrado ninguna aplicación con nombre \"[[resourceName]]\".",
	"error.accountNotFound": "No existe la cuenta \"[[account]]\".",
	"error.lookupUserNotFound": "Usuario con correo electrónico \"[[name]]\" no ha sido encontrado.",
	"error.callerNotFound": "Usuario con correo electrónico \"[[caller]]\" no ha sido encontrado en la cuenta \"[[account]]\".",
	"error.userNotFound": "Usuario con correo electrónico \"[[name]]\" no ha sido encontrado en la cuenta \"[[account]]\".",
	"error.roleNotFound": "Rol con nombre \"[[roleName]]\" no ha sido encontrado en la cuenta \"[[account]]\".",
	"error.applicationNotFound": "Aplicación con nombre \"[[applicationName]]\" no ha sido encontrada en la cuenta \"[[account]]\".",
	"error.environment": "Ha ocurrido un error inesperado al manejar esta solicitud.",
	"error.gatewayContainerNotFound": "Ha ocurrido un error inesperado al manejar esta solicitud.",
	"error.gatewayContainerInvalid": "Ha ocurrido un error inesperado al manejar esta solicitud.",
	"error.badRequestParameters": "Ha ocurrido un error inesperado al manejar esta solicitud.",
	"error.resend.fail": "Ha ocurrido un error inesperado, No se puede volver a enviar la invitación.",
	// 073117
	"groups.tagger.placeholder": "+ Grupo",
	"groups.tagger.secondaryPlaceholder": "Añadir un grupo nuevo",
	"home.link.summary": "Resumen: Ver todas las aplicaciones y grupos de usuarios",
	"tag.placeholder.label.group": "[[group]] (Grupo Nuevo)",
	// 081017
	"application.wizard.networkService.title": "Crear una red protegida",
	"application.wizard.selectType.title": "Crear una aplicación protegida",
	"application.wizard.selectType.type.message": "¿Se trata de una aplicación web o un servicio de red?",
	"application.wizard.summary.title": "Revisar la aplicación protegida",
	"application.wizard.web.title": "Crear una aplicación web protegida",
	"application.wizard.web.url.message": "¿Cuál es la URL completa de la aplicación web que desea proteger?",
	"application.wizard.web.form.label.web": "URL de la aplicación",
	"applications.title": "Definir aplicaciones protegidas",
	"users.title": "Definir Usuarios y Grupos",
	// 081417
	"forgotpassword.verify.2": "Si está asociado con cuentas y grupos SafeConnect SDP existentes",
	// 081717
	"form.label.identityProvider": "Proveedor de Identidad",
	"form.label.attributes": "Atributos de grupo",
	"form.label.groups": "Valores del Grupo",
	"error.account.delete": "El nombre de la cuenta debe ser ingresado para borrar la cuenta.",
	// 081817
	"error.form.name.pattern": "El nombre de la aplicación debe ser sólo caracteres alfanuméricos.",
	"imageManager.selector.button.default": "Restablecer imagen",
	"user.wizard.userEdit.title": "Crear un usuario",
	"user.wizard.groupsToUsers.createGroup": "Añadir",
	"sdp.label.policy": "Política",
	"sdp.label.status": "Estado",
	"sdp.label.gateway": "Gateway SDP",
	// 082117
	"home.link.rules": "Políticas: Las condiciones requeridas para que los Usuarios tengan acceso a una Aplicación.",
	"assignApplications.title": "Definir políticas",
	"assignApplications.header.title": "Políticas",
	"imageManager.selector.text": `Seleccione una imagen que se mostrará a los usuarios finales para ayudar a
		identificar la aplicación protegida.`,
	"application.wizard.selectType.name.message": `¿Cuál es el nombre de su aplicación protegida?
        Este será el nombre que se mostrará a los usuarios finales.`,
	"sdp.done.descriptive": "Haga click en \"Listo\" para ir a las aplicaciones protegidas.",
	"application.wizard.web.settings.message": `La opción de abajo es necesaria para las aplicaciones que requieran periódicamente
        una nueva conexión.`,
	"applications.label.requiresKeepalive.true": "Permitir que la aplicación establezca periódicamente nuevas conexiones.",
	"applications.label.requiresKeepalive.false": "Permitir sólo la conexión inicial a la aplicación.",
	"application.wizard.networkService.urlDescription": `Antes de que el acceso a una aplicación cliente se inicie, se debe configurar
	en la máquina del usuario final el manejador para enlazar la URL definida para cada protocolo utilizado. Más información sobre
        cómo configurar los manejadores de URL para los protocolos comunes se puede encontrar en nuestra ayuda.`,
	"user.samlGrid.title": "SAML",
	"user.userGrid.title": "Usuario",
	"assignApplications.update.success.message.roles": `Se han actualizado las políticas de \"[[applicationName]]\".`,
	"imageManager.file.info": "La imagen se dimensionara a 160 x 60 píxeles.",
	// 082217
	"groups.info": `Las políticas determinan los requisitos que se deben cumplir para acceder a una aplicación.`,
	"user.info.block.1": `Cree usuarios internos para acceder a sus aplicaciones protegidas.`,
	"user.saml.block.1": `Configure SAML para autenticación y autorización.`,
	"home.info.block.1": ` Es una solución SDP en la nube, fácil de implementar, que proporciona protección avanzada
        para sus recursos al asegurar el acceso a sus aplicaciones protegidas.`,
	"home.info.block.2": `Haga clic en "Siguiente" para comenzar!`,
	"summary.description": `Este es un resumen de las aplicaciones definidas y los requisitos para acceder a dichas aplicaciones. Antes de
        que se complete la configuración de SDP, asegúrese de que el acceso a las aplicaciones protegidas sólo está permitido
         desde la dirección IP del Gateway SDP`,
	"home.link.policies": "Políticas: Determinan los requisitos que deben cumplirse para acceder a una aplicación.",
	"user.wizard.groupsToUsers.title": "Asignar Grupos a los Usuarios",
	"user.wizard.groupsToUsers.optionsHeader": "Grupos Disponibles",
	"user.wizard.groupsToUsers.selectedHeader": "Grupos Seleccionados",
	"user.wizard.groupsToUsers.searchPlaceholder": "Buscar grupos",
	"user.wizard.groupsToUsers.createGroupPlaceholder": "Crear Grupo Nuevo"
};
